import { baseApi } from '@/api/rtk/baseApi';
import { runMutation } from '@/api/rtk/runEndpoint';
import '@/api/rtk/mutationsApi';
import '@/api/rtk/reportsApi';

export const createRecord = async ({
  reportId,
  userId,
  toolFieldsData,
  reportLanguage,
  uses_custom_template,
  audioLanguage,
  comment = '',
  template,
  meta_type,
  toolId,
  urgent,
  integration,
  enableTextModules,
  activateIcdCodes,
  isPrivate,
}) => {
  const dataToSend = {
    report_id: reportId,
    status: 'uploading',
    report: '',
    tool_fields: toolFieldsData,
    audio_language: audioLanguage,
    report_language: reportLanguage,
    user_id: userId,
    uses_custom_template,
    template,
    comment,
    tool_id: toolId,
    urgent,
    integration,
    enableTextModules,
    activateIcdCodes,
    isPrivate,
    meta_type: meta_type || 'mp3',
  };

  try {
    return await runMutation(baseApi.endpoints.createRecord, dataToSend);
  } catch {
    return null;
  }
};

export const handleUpdateStatus = async ({ documentId, status }) => {
  try {
    const data = await runMutation(baseApi.endpoints.updateReportStatus, {
      id: documentId,
      status,
    });
    return data?.id || data || null;
  } catch {
    return null;
  }
};

export const handleUpdateError = async ({ id, error, context }) => {
  try {
    const data = await runMutation(baseApi.endpoints.updateReportError, {
      error,
      status: 'completed',
      context,
      id,
    });
    return data?.message ?? null;
  } catch {
    return null;
  }
};

export const getReport = async (id, token) => {
  try {
    return await runMutation(baseApi.endpoints.getReportByIdToken, { id, token });
  } catch {
    return null;
  }
};

const updateServiceName = async ({ user_id, service_name }) => {
  try {
    const data = await runMutation(baseApi.endpoints.updateServiceName, {
      user_id,
      service_name,
    });
    return data?.user ?? null;
  } catch {
    return null;
  }
};

export const checkIfOnline = async () => {
  try {
    const user_id = localStorage.getItem('user_id');
    const response = await updateServiceName({ user_id, service_name: 'anthropic' });
    return !!response;
  } catch {
    return false;
  }
};
